export const API_PLATFORM_ENDPOINT = `${location.origin}/atr-framework-services`;
